import React, { Component } from 'react'
import { Toast, List, Flex} from 'antd-mobile'
import { ORG_CODE, FARM_ORG } from '../../cache'
import LinkText from './components/link'
import df from 'dateformat'
import './index.css'
import Table from '../../components/Table';
import MateGroup from './components/mate-group';
import send from '../../utils/send';
import EmptyReport from "../../components/EmptyReport";
let birthWeekSource = [];
class Report08 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showStart: false,
      showEnd: false,
      startDate: new Date(),
      endDate: new Date(),
      birthWeekSource,
      startWeek: '1905',
      endWeek: '2008',
      columns: [
        {
          'id': 'sub_category_name_loc',
          'title': '',
          width: 100,
          'align': 'left',
          'fixed': true
        }
      ],
      tableData: []
    }
  }
  async componentDidMount() {
    // let birthWeek = await send({
    //   url: '/api/forward/ifarm/getWeekYearly',
    //   method: 'GET'
    // });
    let birthWeek = await send({
      url: '/api/forward/ifarm/getWeekYearly',
      method: 'GET'
    });
    birthWeekSource = birthWeek.data;
    this.setState({
      startDate: birthWeekSource[2].weekStartDate,
      startWeek: birthWeekSource[2].mateGroup,
      endDate: birthWeekSource[0].weekEndDate,
      endWeek: birthWeekSource[0].mateGroup
    }, () => {
      this.doSearch()
    })
  }

  onCancel = () => {
    this.setState({
      showStart: false,
      showEnd: false
    })
  };
  doSearch = () => {
    const {startDate, endDate,startWeek,endWeek} = this.state;
    Toast.loading('请稍候', 0);
    console.log('doSearch ', startDate, endDate,startWeek,endWeek);
    send({
      url: '/api/forward/ifarm/report8',
      method: 'POST',
      data: {
        farmOrg: FARM_ORG,
        orgCode: ORG_CODE,
        startDate: startDate,
        endDate: endDate
      }
    }).then(res => {
      Toast.hide();
      let tableData = res.data;
      const flag = tableData instanceof Array;
      if (!flag) {
        Toast.hide();
        return;
      }
      if(tableData.length === 0) {
        this.setState({tableData: []});
        return
      }
      let resData = tableData[0];
      let columns = [
        {
          'id': 'sub_category_name_loc',
          'title': '指标',
          'align': 'left',
          'width': 100,
          'fixed': true,
          render(d,index) {
            if (tableData[index].sub_category_name_loc !== 'spaceline') {
              return <div style={{width: 100,wordBreak: 'break-all'}}>{tableData[index].sub_category_name_loc}</div>
            } else {
              return <div style={{width: 100,wordBreak: 'break-all'}} />
            }
          }
        }
      ];
      for (var i = 1; i < 300; i++) {
        let keyStr = `empl${i}NameLoc`;
        let valStr = `empl${i}Val`;
        let IdStr = `empl${i}ID`;
        if (resData[keyStr]){
          columns.push({
            'id': valStr,
            'title': resData[IdStr] + resData[keyStr],
            render: function (data) {
              if (data.sub_category_name_loc === 'spaceline') {
                return ''
              } else {
                return <div>{data[valStr]}</div>
              }
            }
          })
        }
      }
      this.setState({columns,tableData})
    })

  };
  render() {
    const {showStart, showEnd, startDate,endDate, startWeek, endWeek} = this.state;
    return (
      <React.Fragment>
        <div className="oneH">
          <List>
            <Flex className={showStart || showEnd? 'single-multi-menu-active' : ''}>
              <Flex.Item className={'single-multi-top-nav-bar'}>
                <List.Item onClick={() => {
                  this.setState({
                    showStart: !showStart,
                    showEnd: false
                  })}
                }
                >
                  <LinkText show={showStart}>配种组开始日期</LinkText>
                </List.Item>
              </Flex.Item>
              <Flex.Item className={'single-multi-top-nav-bar'}>
                <List.Item onClick={() => {
                  this.setState({
                    showStart: false,
                    showEnd: !showEnd
                  })}
                }
                >
                  <LinkText show={showEnd}>配种组截止日期</LinkText>
                </List.Item>
              </Flex.Item>
            </Flex>
          </List>
          {
            showStart ? <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
              <MateGroup data={birthWeekSource}
                         onCancel={() => {
                           this.setState({
                             showStart: false
                           })}
                         }
                         onConfirm={(value, data) => {
                           this.setState({
                             startWeek: value,
                             startDate: data.weekStartDate,
                             showStart: false
                           }, () => {
                             this.doSearch()
                           })
                         }}
                         value={startWeek}
              />
            </div>: null
          }

          {
            showEnd ? <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
              <MateGroup data={birthWeekSource}
                         onCancel={() => {
                           this.setState({
                             showEnd: false
                           })}
                         }
                         onConfirm={(value, data) => {
                           this.setState({
                             endWeek: value,
                             endDate: data.weekEndDate,
                             showEnd: false
                           }, () => {
                             this.doSearch()
                           })
                         }}
                         value={endWeek}
              />
            </div>: null
          }
          <List.Item
            className="span-4"
            disabled
            extra={df(startDate, 'yyyy-mm-dd') + ' ~ ' + df(endDate, 'yyyy-mm-dd')}
          >
            时间范围
          </List.Item>
          {
            showStart || showEnd ? <div className="menu-mask"/> : null
          }

          {this.state.tableData.length > 0 ?
            <Table columns={this.state.columns}
                   data={this.state.tableData}
                   stripe
            />
            : <EmptyReport height={250} />}
        </div>
      </React.Fragment>
    )
  }
}

export default Report08
